import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { UserPersonService } from '@core/services/entities/user-person.service';
import { CreateUserPersonRequestDto } from '@domain/user-person/dtos/create-user-person.request.dto';
import { GetUserPersonRequestDto } from '@domain/user-person/dtos/get-user-person.request.dto';
import { ListUserPersonRequestDto } from '@domain/user-person/dtos/list-user-person.request.dto';
import { UpdateStateUserPersonRequestDto } from '@domain/user-person/dtos/update-state-user-person.request.dto';
import { UpdateUserPersonRequestDto } from '@domain/user-person/dtos/update-user-person.request.dto';
import { UpdatePinUserPersonRequestDto } from '@domain/user-person/dtos/update-pin-user-person.request.dto';
import { UserPersonResponseDto } from '@domain/user-person/dtos/user-person.response.dto';
import { UserPersonRepository } from '@domain/user-person/repositories/user-person.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserPersonRepositoryService implements UserPersonRepository {
  constructor(private userPersonService: UserPersonService) {}

  create(
    request: CreateUserPersonRequestDto,
  ): Observable<ApiResponse<UserPersonResponseDto>> {
    return this.userPersonService.create(request);
  }
  update(
    request: UpdateUserPersonRequestDto,
  ): Observable<ApiResponse<UserPersonResponseDto>> {
    return this.userPersonService.update(request);
  }
  updateState(
    request: UpdateStateUserPersonRequestDto,
  ): Observable<ApiResponse<UserPersonResponseDto>> {
    return this.userPersonService.updateState(request);
  }

  updatePin(
    request: UpdatePinUserPersonRequestDto,
  ): Observable<ApiResponse<UserPersonResponseDto>> {
    return this.userPersonService.updatePin(request);
  }

  show(request: RefId): Observable<ApiResponse<UserPersonResponseDto>> {
    return this.userPersonService.show(request);
  }
  list(
    request: ListUserPersonRequestDto,
  ): Observable<ApiResponse<PageableResponse<UserPersonResponseDto>>> {
    return this.userPersonService.list(request);
  }
  get(
    request: GetUserPersonRequestDto,
  ): Observable<ApiResponse<UserPersonResponseDto[]>> {
    return this.userPersonService.get(request);
  }
}
